import { render } from "./sconfig.vue?vue&type=template&id=7dc73561&scoped=true"
const script = {}

import "./sconfig.vue?vue&type=style&index=0&id=7dc73561&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc73561"]])

export default __exports__